document.addEventListener('DOMContentLoaded', function () {
  const selectOptions = document.querySelectorAll('select option');
  const variantInputs = document.querySelectorAll('input[type="radio"][data-variant-id]');

  if (selectOptions?.length === 0 || variantInputs?.length === 0) {
    return;
  }

  function resolveVariantIdByText(text) {
    const option = Array.from(selectOptions).find(option => option.innerText === text);

    if (!option) {
      return;
    }

    return option.value;
  }

  function resolveVariantTextById(id) {
    const option = Array.from(selectOptions).find(option => option.value === id);

    if (!option) {
      return;
    }

    return option.innerText;
  }

  function setQueryFromActiveOptions(url) {
    const activeInputs = document.querySelectorAll('input[type="radio"]:checked');

    const textArray = [];

    activeInputs.forEach(input => {
      textArray.push(input.getAttribute('value'));
    });

    const text = textArray.join(' / ');
    const variant = resolveVariantIdByText(text);

    url.searchParams.set('variant', variant);
    window.history.replaceState(null, '', url.toString());
  }

  function setDefaultVariant() {
    const url = new URL(window.location.href);
    const queryVariant = url.searchParams.get('variant');

    if (!queryVariant) {
      setQueryFromActiveOptions(url);
    } else {
      variantInputs.forEach(input => {
        input.removeAttribute('checked');
      });

      const variant = resolveVariantTextById(queryVariant);

      if (!variant) {
        return;
      }

      if (variant.includes(' / ')) {
        const splittedVariant = variant.split(' / ');

        splittedVariant.forEach(item => {
          const option = document.querySelector(`input[type="radio"][value="${item}"]`);

          option?.setAttribute('checked', true);
        });
      } else {
        const option = document.querySelector(`input[type="radio"][value="${variant}"]`);

        option?.setAttribute('checked', true);
      }
    }
  }

  function handleVariantChange() {
    const url = new URL(window.location.href);
    setQueryFromActiveOptions(url);
  }

  setDefaultVariant();

  variantInputs.forEach(input => {
    input.addEventListener('change', handleVariantChange);
  });
});